import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface GuestRouteProps {
  children: React.ReactNode;
  adminOnly?: boolean;
}

export default function GuestRoute({ children, adminOnly = false }: GuestRouteProps) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-900 text-stone-400">
        <i className="ri-loader-4-line text-2xl animate-spin" />
      </div>
    );
  }

  if (user) {
    if (user.role === 'staff' || user.role === 'admin') {
      return <Navigate to="/admin/dashboard" replace />;
    }
    if (!adminOnly) {
      return <Navigate to="/account/orders" replace />;
    }
  }

  return <>{children}</>;
}
